import { api } from './client';

// =================== UKTZED ===================

export interface UktzedCodeListItem {
  code: string;
  code_formatted: string;
  name_uk: string;
}

export interface UktzedCode extends UktzedCodeListItem {
  id: string;
  import_duty_rate_preferential: string | null;
  import_duty_rate_full: string | null;
  uom_code: string | null;
  parent_code: string;
  is_active: boolean;
  seed_source: string;
  valid_from: string | null;
  valid_until: string | null;
  created_at: string;
  updated_at: string;
}

export interface UktzedSearchResponse {
  items: UktzedCodeListItem[];
  total: number;
}

export const uktzedCodes = {
  search: (params?: {
    q?: string;
    code_prefix?: string;
    parent_code?: string;
    active_only?: boolean;
    limit?: number;
    offset?: number;
  }) =>
    api.get<UktzedSearchResponse>('/refs/uktzed-codes', { params })
      .then((r) => r.data),
  get: (code: string) =>
    api.get<UktzedCode>(`/refs/uktzed-codes/${code}`).then((r) => r.data),
};

// =================== Tax Purposes ===================

export interface TaxPurpose {
  id: string;
  code: string;
  name_uk: string;
  description: string | null;
  is_active: boolean;
  seed_source: string | null;
  created_at: string;
  updated_at: string;
}

export interface TaxPurposeCreate {
  code: string;
  name_uk: string;
  description?: string | null;
  is_active?: boolean;
}

export type TaxPurposeUpdate = Partial<Omit<TaxPurposeCreate, 'code'>>;

export const taxPurposes = {
  list: () =>
    api.get<TaxPurpose[]>('/refs/tax-purposes').then((r) => r.data),
  get: (id: string) =>
    api.get<TaxPurpose>(`/refs/tax-purposes/${id}`).then((r) => r.data),
  create: (payload: TaxPurposeCreate) =>
    api.post<TaxPurpose>('/refs/tax-purposes', payload).then((r) => r.data),
  update: (id: string, payload: TaxPurposeUpdate) =>
    api.patch<TaxPurpose>(`/refs/tax-purposes/${id}`, payload).then((r) => r.data),
  remove: (id: string) =>
    api.delete(`/refs/tax-purposes/${id}`).then(() => undefined),
};

// =================== Taxation Schemes ===================

export interface TaxationScheme {
  id: string;
  code: string;
  name_uk: string;
  has_vat: boolean;
  profit_tax_rate: string | null;
  single_tax_rate: string | null;
  description: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface TaxationSchemeCreate {
  code: string;
  name_uk: string;
  has_vat?: boolean;
  profit_tax_rate?: string | null;
  single_tax_rate?: string | null;
  description?: string | null;
  is_active?: boolean;
}

export type TaxationSchemeUpdate = Partial<Omit<TaxationSchemeCreate, 'code'>>;

export const taxationSchemes = {
  list: () =>
    api.get<TaxationScheme[]>('/refs/taxation-schemes').then((r) => r.data),
  get: (id: string) =>
    api.get<TaxationScheme>(`/refs/taxation-schemes/${id}`).then((r) => r.data),
  create: (payload: TaxationSchemeCreate) =>
    api.post<TaxationScheme>('/refs/taxation-schemes', payload).then((r) => r.data),
  update: (id: string, payload: TaxationSchemeUpdate) =>
    api.patch<TaxationScheme>(`/refs/taxation-schemes/${id}`, payload).then((r) => r.data),
  remove: (id: string) =>
    api.delete(`/refs/taxation-schemes/${id}`).then(() => undefined),
};
